import { AREA, BAR, COLUMN, DONUT, LINE, PIE } from 'reporting-data/constants/chartTypes';
import { getReportChartType } from 'reporting-data/report/reportGetters';
import { CUSTOM_WIDGET_TYPES } from 'reporting-data/tsTypes/customWidgetTypes';
import { isConfigReport, isFunnelReport } from 'reporting-data/tsTypes/reportTypes';
import { customWidgetTypeIncludes } from 'reporting-ui-components/components/customWidgets/utils';
const UNSUPPORTED_WIDGETS = [CUSTOM_WIDGET_TYPES.CHANGE_HISTORY_DEAL_LIST, CUSTOM_WIDGET_TYPES.WATERFALL];
const SUPPORTED_CHART_TYPES = [AREA, BAR, COLUMN, DONUT, LINE, PIE];
export const isReportValidForColorThemeDropdown = report => {
  return isConfigReport(report) && !isFunnelReport(report) && SUPPORTED_CHART_TYPES.includes(getReportChartType(report) || '') && !customWidgetTypeIncludes(report, UNSUPPORTED_WIDGETS);
};